export class RequestUrgencyCounterByDayApi
{
    dateUtc: string;
    urgencies: RequestUrgencyCounterApi[];
    totalCreated: number;
    totalClosed: number;
}

export class RequestUrgencyCounterApi
{
    urgencyId: number;
    countCreated: number;
    countClosed: number;
}